import { PRESSURE_UNIT, RAIN_UNIT, SPEED_UNIT, TEMPERATURE_UNIT } from './constants';

export function convertTemperature(value, unit) {
	return unit === TEMPERATURE_UNIT.F
		? 32 + 1.8 * value
		: value;
}

export function convertTemperatureTrend(value, unit) {
	return unit === TEMPERATURE_UNIT.F
		? 1.8 * value
		: value;
}

export function convertRainfall(value, unit) {
	return unit === RAIN_UNIT.IN
		? value / 25.4
		: value;
}

export function convertPressure(value, unit) {
	return unit === PRESSURE_UNIT.INHG
		? value / 33.8638867
		: value;
}

export function convertWindSpeed(value, unit) {
	switch (unit) {
		case SPEED_UNIT.MPH:
			return 0.6214 * value;
		case SPEED_UNIT.KNOTS:
			return 0.54 * value;
		case SPEED_UNIT.MS:
			return value / 3.6;
		default:
			return value;
	}
}



// WEBPACK FOOTER //
// ./utils/unit-converters.js